// NowLine (round 2): the red line at now, drawn through a lane's track, under its visits so it never
// crosses a block's words (DESIGN.md §2: red is a time that needs watching, and now is the one line on
// the board that moves). It has no words: TimeScale names it ("Now 10:30"). Off the board's day, or on
// another day, it isn't drawn. Reads only --now-*.
import { spanPct, useTimeSpan } from '../time-span.tsx';
import './NowLine.css';

export function NowLine() {
  const span = useTimeSpan();
  if (span.now === null || span.now < span.from || span.now > span.to) return null;
  return (
    <span className="fl-now" style={{ insetInlineStart: `${spanPct(span, span.now)}%` }} aria-hidden="true" />
  );
}
